const HIGH_MAST_DEFECT_CODE_PREFIX = 'hm_';

const HIGH_MAST_BINARY_DEFECT_CODES = new Set([
  'hm_crack_pole_ring',
  'hm_crack_footing',
  'hm_hinges_lock',
  'hm_cable_condition',
  'hm_foreign_objects'
]);

/**
 * High Mast stores graded (L1-L3) and binary (Yes/No) choices in one scheme.
 * Every other asset type must receive its severity scheme unchanged.
 */
export const filterSeverityLevelsForDefect = (severityLevels = [], defectTypeCode = '') => {
  if (!Array.isArray(severityLevels)) return [];

  const normalizedCode = typeof defectTypeCode === 'string'
    ? defectTypeCode.toLowerCase()
    : '';

  if (!normalizedCode.startsWith(HIGH_MAST_DEFECT_CODE_PREFIX)) {
    return severityLevels;
  }

  if (HIGH_MAST_BINARY_DEFECT_CODES.has(normalizedCode)) {
    return severityLevels.filter((level) => level.value >= 4);
  }

  return severityLevels.filter((level) => level.value <= 3);
};
